import util from '@/libs/util.js'
import { AccountLogin } from '@/api/sys/login'
import { get } from "@/plugin/newAxios";

export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param TellerId {String} 用户账号
     * @param {Object} param pwd {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象
     */
    login ({ dispatch }, {
      vm,
      userName,
      pwd,
      entName,
      _vTokenName,
      phoneCountryCode,
      flag,
      language,
      result,
      smsSource,
      code,
      route = {
        name: 'index'
      }
    }) {
      // 开始请求登录接口
      AccountLogin({
        userName,
        pwd,
        entName,
        _vTokenName,
        phoneCountryCode,
        flag,
        language,
        result,
        smsSource,
        code
      })
        .then(async res => {
          if (res.data.code == '304') {
            vm.$eventBus.$emit('showRegisterProgressBar', res.data);
          } else if (res.data.code == '423') {
            vm.$confirm(window.vm.$i18n.t('login.logintip2') + '!', window.vm.$i18n.t('parrent.ts'), {
              confirmButtonText: window.vm.$i18n.t('parrent.qd'),
              showCancelButton: false,
              showClose: false,
              closeOnClickModal: false,
              customClass: 'messageBox-phase',
              type: 'error',
              center: true,
            }).then(() => {

            })
          } else if (res.data.code == '425') {
            vm.$confirm(window.vm.$i18n.t('login.logintip3') + '!', window.vm.$i18n.t('parrent.ts'), {
              confirmButtonText: window.vm.$i18n.t('parrent.qd'),
              showCancelButton: false,
              showClose: false,
              closeOnClickModal: false,
              customClass: 'messageBox-phase',
              type: 'error',
              center: true,
            }).then(() => {

            })
          } else {
            //  console.log(vm.$route.fullPath)
            if (res.data.role[0]) {
              let arr = res.data.role[0].children
              let arr1 = []
              Object.assign(arr1, arr)
              arr1 = arr1.filter(item => item.path !== '/settings' && item.path !== '/myMessage');
              vm.$store.commit('d2admin/menu/headerSet', arr1)
              window.sessionStorage.setItem('initMenu', JSON.stringify(res.data.role[0].children))
              if (vm.$route.fullPath != "/login") {
                location.reload()
              }
            }
                        
            window.sessionStorage.setItem('userState', res.data.userState);
            window.sessionStorage.setItem('entState', res.data.entState);
            window.sessionStorage.setItem('userId', res.data.userId);
            window.sessionStorage.setItem('userName', res.data.userName);
            window.sessionStorage.setItem('entId', res.data.entId);
            window.sessionStorage.setItem('ent', res.data.entName);
            window.sessionStorage.setItem('rights', JSON.stringify(res.data.rights));
            window.sessionStorage.setItem('sjBs', res.data.sjBs)
            // 从res中获取token
            const token = res.data.token;
            // 把token保存到sessionStorage中
            sessionStorage.setItem('token', token);
            // 设置 vuex 用户信息
            await dispatch('d2admin/user/set', {
              UserInfoMap: res.data
            }, { root: true })

            // 通过userid获取登录用户的证件有效期
            await new Promise((resolve) => {
              vm.$eventBus.$emit('showValidityPeriod', {
                userId: res.data.userId,
                onConfirm: resolve
              });
            })
            if (res.data.sjBs == 0) {
              get(`khfw/v1/user-manager/getUserEnableStatus/${res.data.userId}`).then(res => {
                sessionStorage.setItem('userEnableStatus', res.data)
              })
            } else {
              sessionStorage.setItem('userEnableStatus', 0)
            }

            // 更新路由 尝试去获取 cookie 里保存的需要重定向的页面完整地址
            const path = util.cookies.get('redirect')
            // 根据是否存有重定向页面判断如何重定向
            if (Object.keys(vm.$route.query).length > 0) {
              vm.$router.replace({
                path: '/shipmentBusiness/intlPeriodApply',
                query: vm.$route.query
              });
            } else {
              // vm.$router.replace(path ? (path == '/register' ? route : (path == '/forgotPassword' ? route : path)) : route)
              vm.$router.replace(
                path
                  ? (
                      path === '/register' ||
                      path === '/forgotPassword' ||
                      path === '/settings/changePhone'
                      ? route: path
                    ): route
              )
            }
            // 删除 cookie 中保存的重定向页面
            // if (res.data.entUserId == res.data.userId) {
            // if(!res.data.electronicSignatureId){
            //   vm.$confirm('为了方便使用电子签章，请您在个人设置-企业信息处录入USBkey序列号!', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     showClose:false,
            //     type: 'warning',
            //     closeOnClickModal:false,
            //     closeOnPressEscape:false
            //   }).then(() => {
            //     vm.goto({
            //       path: '/',
            //       name: 'settings',
            //       params:{page:'entInfo'}
            //     });
            //   }).catch(() => {
            //   });
            // }
            // }
            util.cookies.remove('redirect');
            // setTimeout(() => {
              
            // });
            // console.log(vm.$route.fullPath)

            
          }
        })
        .catch(err => {
          vm.isLogin = false;
        })
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout ({ commit }, { vm, confirm = false }) {
      /**
       * @description 注销
       */
      function logout () {
        // 删除cookie
        util.cookies.remove('userInfo')
        util.cookies.remove('List')
        util.cookies.remove('todoList')

        //跳转路由
        vm.$router.push({
          name: 'login'
        })
      }

      // 判断是否需要确认
      if (confirm) {
        commit('d2admin/gray/set', true, { root: true })
        vm.$confirm('注销当前账户吗?  打开的标签页和用户设置将会被保存。', '确认操作', {
          confirmButtonText: '确定注销',
          cancelButtonText: '放弃',
          type: 'warning'
        })
          .then(() => {
            commit('d2admin/gray/set', false, { root: true })
            logout()
          })
          .catch(() => {
            commit('d2admin/gray/set', false, { root: true })
            vm.$message('放弃注销用户')
          })
      } else {
        logout()
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     */
    load ({ commit, dispatch }) {
      return new Promise(async resolve => {
        // DB -> store 加载用户名
        await dispatch('d2admin/user/load', null, { root: true })
        // DB -> store 加载主题
        await dispatch('d2admin/theme/load', null, { root: true })
        // DB -> store 加载页面过渡效果设置
        await dispatch('d2admin/transition/load', null, { root: true })
        // DB -> store 持久化数据加载上次退出时的多页列表
        await dispatch('d2admin/page/openedLoad', null, { root: true })
        // DB -> store 持久化数据加载侧边栏折叠状态
        // await dispatch('d2admin/menu/asideCollapseLoad', null, {root: true})
        // DB -> store 持久化数据加载全局尺寸
        await dispatch('d2admin/size/load', null, { root: true })
        // end
        resolve()
      })
    }
  }
}
